/* ============================================================================
 * size-description.js — size-info line UNDER the size selector.
 * Line: "{poster} — {recommendation} ({framedLabel} {framed})"
 *   - numbers by MARKET (US/CA inch, else cm); words by LANGUAGE (Shopify.locale)
 *   - per-Format tweaks: hide the framed part (e.g. Satin Canvas) + size overrides
 * Anchored to the SIZE option group only (never the whole options block), and
 * survives Minimog re-rendering on variant change (a MutationObserver re-inserts
 * / re-positions / refreshes the line after the theme redraws).
 * Display only; buttons & SKU untouched. Load size-i18n.js first, and set:
 *   <script>window.__MARKET_COUNTRY = "{{ localization.country.iso_code }}";</script>
 * ==========================================================================*/
(function () {
  'use strict';
  var KEYS = ['XS', 'S', 'M', 'L', 'XL'];
  var US_COUNTRIES = { US: 1, CA: 1 };
  var INFO_ID = 'size-info-line';

  function market() {
    var iso =
      (typeof window.__MARKET_COUNTRY === 'string' && window.__MARKET_COUNTRY) ||
      (window.Shopify && window.Shopify.country) || '';
    return US_COUNTRIES[String(iso).toUpperCase()] ? 'US' : 'EU';
  }
  function lang() {
    var l = (window.Shopify && window.Shopify.locale) ||
            document.documentElement.getAttribute('lang') || 'en';
    return String(l).slice(0, 2).toLowerCase();
  }
  function tr() {
    var t = window.SIZE_I18N && window.SIZE_I18N.t;
    return t ? (t[lang()] || t.en) : null;
  }
  function isSizeRadio(r) { return KEYS.indexOf((r.value || '').trim()) !== -1; }
  function sizeRadios() {
    return Array.prototype.slice
      .call(document.querySelectorAll('input[type="radio"]'))
      .filter(isSizeRadio);
  }
  function selectedSize(radios) {
    var checked = radios.filter(function (r) { return r.checked; })[0];
    if (checked) return (checked.value || '').trim();
    return radios[0] ? (radios[0].value || '').trim() : null;
  }
  function selectedFormatConfig(formats) {
    if (!formats) return null;
    var checked = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]:checked'));
    for (var i = 0; i < checked.length; i++) {
      var v = (checked[i].value || '').trim();
      if (formats[v]) return formats[v];
    }
    return null;
  }
  // The SIZE option's own wrapper: climb from the selected size radio while the
  // ancestor still contains ONLY size radios. Stops before the wrapper that also
  // holds Format/Margin radios — so the line never lands under the whole block.
  function sizeAnchor() {
    var all = sizeRadios();
    if (!all.length) return null;
    var ref = all.filter(function (r) { return r.checked; })[0] || all[0];
    if (!ref) return null;
    var g = ref.parentElement, best = null;
    while (g) {
      var arr = Array.prototype.slice.call(g.querySelectorAll('input[type="radio"]'));
      if (arr.length && arr.every(isSizeRadio)) { best = g; g = g.parentElement; }
      else break;
    }
    return best || ref.parentElement;
  }
  // Create the line if missing, and keep it right after the size group.
  function ensureInfo() {
    var anchor = sizeAnchor();
    if (!anchor) return null;
    var el = document.getElementById(INFO_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = INFO_ID;
      el.className = 'size-info-line';
      el.setAttribute('style', 'margin-bottom:8px;margin-top:-8px;font-size:16px;line-height:1.45;color:#555;');
    }
    if (anchor.nextElementSibling !== el) anchor.insertAdjacentElement('afterend', el);
    return el;
  }
  function computeText() {
    var data = window.SIZE_I18N;
    if (!data) return null;
    var radios = sizeRadios();
    if (!radios.length) return null;
    var k = selectedSize(radios);
    var mk = market();
    var T = tr();
    var base = k && data.dims[mk] && data.dims[mk][k];
    if (!base || !T) return '';
    var poster = base.poster, framed = base.framed;
    var fc = selectedFormatConfig(data.formats);
    if (fc && fc.overrides && fc.overrides[mk] && fc.overrides[mk][k]) {
      var ov = fc.overrides[mk][k];
      if (ov.poster) poster = ov.poster;
      if (ov.framed) framed = ov.framed;
    }
    var noFrame = !!(fc && fc.noFrame);
    var rec = (T.recommend && T.recommend[k]) || '';
    return poster + ' — ' + rec + (noFrame ? '' : (' (' + T.framed + ' ' + framed + ')'));
  }
  // Idempotent: only mutates the DOM when placement or text actually changed,
  // so it is safe to call repeatedly from a MutationObserver.
  function render() {
    var txt = computeText();
    if (txt === null) return;
    var el = ensureInfo();
    if (!el) return;
    if (el.textContent !== txt) el.textContent = txt;
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 80); }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) schedule();
  }, true);
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  function boot() {
    render();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    [150, 500, 1200, 2500].forEach(function (ms) { setTimeout(render, ms); });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.SizeInfoLine = { render: render, market: market, lang: lang };
})();
